import styled, { css } from 'styled-components';

import { Flex } from '@mixins';

export const Container = styled(Flex)`
  ${() => css`
    flex-direction: column;
    width: 100%;
    gap: 20px;
  `}
`;
